@if (initialized) {
    <form [formGroup]="outletContentForm" (ngSubmit)="submit()" class="p-fluid">

        <!-- Outlet -->
        <div class="field">
            <label for="outletId">Outlet</label>
            <p-select
                    formControlName="outletId"
                    id="outletId"
                    [readonly]="true"
                    [disabled]="true"
                    [options]="outlets"
                    optionLabel="name"
                    optionValue="id"
                    [filter]="true"
                    placeholder="Select outlet">
            </p-select>
            <small class="p-error" *ngIf="outletIdCtrl?.touched && outletIdCtrl?.invalid">
                Outlet is required
            </small>
        </div>

        <!-- Ghost Writer -->
        <div class="field">
            <label for="writerId">Ghost Writer</label>
            <p-select
                    formControlName="writerId"
                    id="writerId"
                    [options]="ghostWriters"
                    optionLabel="name"
                    optionValue="id"
                    [filter]="true"
                    placeholder="Select writer">
            </p-select>
            <small class="p-error" *ngIf="writerIdCtrl?.touched && writerIdCtrl?.invalid">
                Ghost writer is required
            </small>
        </div>

        <!-- Topic -->
        <div class="field">
            <label for="topic">Topic</label>
            <input pInputText id="topic" type="text" formControlName="topic" placeholder="Enter topic"/>
            <small class="p-error" *ngIf="topicCtrl?.touched && topicCtrl.hasError('required')">
                Topic is required
            </small>
            <small class="p-error" *ngIf="topicCtrl?.touched && topicCtrl.hasError('minlength')">
                Min 3 characters
            </small>
        </div>

        <!-- Buttons -->
        <div class="mt-2 flex justify-content-between">
            <button
                    pButton
                    type="submit"
                    class="w-auto"
                    label="Auto Create"
                    [icon]="busy ? 'pi pi-spin pi-spinner' : 'pi pi-plus'"
                    [disabled]="outletContentForm.invalid || busy || promptText">
            </button>

            <button
                    pButton
                    class="w-auto"
                    label="Create Prompt"
                    [icon]="busy ? 'pi pi-spin pi-spinner' : 'pi pi-plus'"
                    (click)="createPrompt()"
                    [disabled]="outletContentForm.invalid || busy || promptGenerated">
            </button>
        </div>

        <!-- Prompt Output -->
        <div *ngIf="promptText" class="field mt-4">
            <label for="promptText">Generated Prompt</label>
            <textarea
                    pTextarea
                    id="promptText"
                    rows="8"
                    readonly
                    [value]="promptText"
                    class="w-full cursor-pointer"
                    (click)="copyPromptToClipboard()"
                    pTooltip="Click to copy"
                    tooltipPosition="top">
      </textarea>
        </div>

        <!-- JSON Input Field -->
        <div *ngIf="promptGenerated" class="field mt-4">
            <label for="jsonInput">JSON Input</label>
            <textarea
                    pTextarea
                    id="jsonInput"
                    rows="6"
                    formControlName="json"
                    name="jsonInput"
                    class="w-full"
                    placeholder='Enter JSON'>
      </textarea>
            <small class="p-error" *ngIf="jsonCtrl?.touched && jsonCtrl.hasError('required')">
                JSON is required
            </small>
            <small class="p-error" *ngIf="jsonCtrl?.touched && jsonCtrl.hasError('minlength')">
                Min 3 characters
            </small>
        </div>

        <!-- Create Button -->
        <div *ngIf="promptGenerated" class="mt-2 flex justify-content-end">
            <button
                    pButton
                    type="button"
                    class="w-auto"
                    label="Create"
                    [icon]="busy ? 'pi pi-spin pi-spinner' : 'pi pi-plus'"
                    (click)="createFromJson()"
                    [disabled]="outletContentForm.invalid || busy">
            </button>
        </div>
    </form>
}